import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { CallIcon, EmailIcon, FBLogo, GitHubLogo, IndeedLogo, LocationIcon, TwitterLogo } from "../../../assets";

// Contact details — update these in one place.
const CONTACT = {
    address: "Plot 416, Sector 14-A, Orangi Town, Karachi",
    phone: "+92 311 0241 969",
    email: "ayanmuradahmed@gmail.com",
};

// Social profiles. Leave a url empty ("") to render the icon without a link
// until the real profile URL is available.
const SOCIAL_LINKS = [
    { name: "Facebook", icon: FBLogo, url: "" },
    { name: "Twitter", icon: TwitterLogo, url: "" },
    { name: "Indeed", icon: IndeedLogo, url: "" },
    { name: "GitHub", icon: GitHubLogo, url: "https://github.com/ayanmurad987" },
];

const EXPLORE_LINKS = [
    { label: "Home", target: "Home" },
    { label: "About Us", target: "aboutus" },
    { label: "Our Services", target: "ourservices" },
    { label: "Portfolio", target: "portfolio" },
    { label: "Contact Us", target: "footer" },
];

export default function Footer() {
    const navigate = useNavigate();

    const goToSection = (elementId) => {
        const scrollTo = () => {
            const element = document.getElementById(elementId);
            if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
        };
        if (window.location.pathname !== "/") {
            navigate("/");
            setTimeout(scrollTo, 300);
        } else {
            scrollTo();
        }
    };

    return (
        <div className="Footer" id="footerContent">
            <div className="footerEmptySection"></div>
            <div className="footerSection1">
                <div className="footerSection1Child1">
                    <div>
                        <p style={{ color: "#FFF", textAlign: "center" }}>
                            We are an all-rounder Mobility and Digital Agency which exists to transform your organization with our team of experts and years of experience.
                        </p>
                    </div>
                    <div className="linkedIcons">
                        {SOCIAL_LINKS.map((social) =>
                            social.url ? (
                                <a
                                    key={social.name}
                                    href={social.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="icons"
                                    aria-label={social.name}
                                >
                                    <img src={social.icon} alt={`${social.name} logo`} className="Logo2" />
                                </a>
                            ) : (
                                <div key={social.name} className="icons" aria-label={social.name}>
                                    <img src={social.icon} alt={`${social.name} logo`} className="Logo2" />
                                </div>
                            )
                        )}
                    </div>
                </div>
                <div className="footerSection1Child2">
                    <h2 className="h1">EXPLORE</h2>
                    <ul className="ul">
                        {EXPLORE_LINKS.map((link) => (
                            <li className="li" key={link.label}>
                                <button
                                    type="button"
                                    className="footer-link"
                                    onClick={() => goToSection(link.target)}
                                >
                                    {link.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="footerSection1Child3">
                    <div className="footerSection1Child2">
                        <h2 className="h1">CONTACT</h2>
                        <div className="location">
                            <div className="locationIcon">
                                <img src={LocationIcon} alt="Location" className="Logo3" />
                            </div>
                            <p style={{ fontSize: 14 }}>{CONTACT.address}</p>
                        </div>
                        <div className="location">
                            <div className="locationIcon" style={{ width: 51 }}>
                                <img src={CallIcon} alt="Phone" className="Logo3" />
                            </div>
                            <p>
                                <a className="footer-contact-link" href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}>
                                    {CONTACT.phone}
                                </a>
                            </p>
                        </div>
                        <div className="location">
                            <div className="locationIcon" style={{ width: 51 }}>
                                <img src={EmailIcon} alt="Email" className="Logo3" />
                            </div>
                            <p style={{ fontSize: 14 }}>
                                <a className="footer-contact-link" href={`mailto:${CONTACT.email}`}>
                                    {CONTACT.email}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footerSection2">
                <p>© {new Date().getFullYear()} Ayan Tech. All rights reserved.</p>
            </div>
        </div>
    );
}
